import { AccessPermissionType } from "./accessPermisionType";
import { WorkflowModele } from "./workflowModele";

export class WorkflowEtapeModele {
  workflowEtapeModeleId: number;
  nom: string;
  numeroOrdre: number;
  workflowModeleId: number;
  accessPermission: AccessPermissionType;

}
